import React, { useEffect, useState } from "react";
import arrowDown from "../../../../../../../../../Assets/Images/arrow-down.svg";
import { getStudentByEvent } from "../../../../../../../../../redux/actions/event";
import { useDispatch, useSelector } from "react-redux";

const Filter = ({ activityId, competitionId, setKid, kid }) => {

  const dispatch = useDispatch();

  const studentList = useSelector(state => state.event.eventStudentList);
  const [name, setName] = useState("");


  useEffect(() => {
    if (name)
      dispatch(getStudentByEvent({ activityId, competitionId, nameLike: name }))
  }, [name])

  const handleInputChange = e => {
    const { value } = e.target;
    if (value.length > 2)
      setName(value);
  }

  return (
    <div className="top-btn-group submission-filter mb-2 d-flex mt-3 border-top-0 d-flex align-items-center">
      <p className="mb-0 fw-bold">Select Student to see their submissions</p>
      <div className="dropdown">
        <button className="btn-outline-bl px-4" type="button" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="true">
          {kid?.name ?? "Select"}
          <img className="ms-2" src={arrowDown} alt="arrowDown" style={{ width: "0.8rem", height: "0.8rem" }} />
        </button>
        <ul className="dropdown-menu">
          <li><input id="searchbar" className="form-control me-2 my-1" type="search" onChange={handleInputChange} aria-label="Search" /></li>
          {studentList?.data?.map((item, key) => <li onClick={() => setKid({ kidId: item?.kidId, name: item?.name })}><span className="dropdown-item" >{item?.name}</span></li>)}
        </ul>
      </div>
    </div>
  );
};

export default Filter;
